<template>
    <text-area :label="label" labelClass="h3" :rows="10" :value="comment" @input="v => $emit('update:comment', v)" v-if="editable"></text-area>
    <be-form-group :label="label" labelClass="h3" v-else>
        <p v-html="formattedComment"></p>
    </be-form-group>
</template>

<script>
    import markup from '../../../../mixins/markup';

    export default {
        mixins: [markup],

        props: {
            editable: Boolean,
            comment: String,
            label: {
                type: String,
                default: 'Anmerkungen',
            },
        },

        computed: {
            formattedComment() {
                return this.comment ? this.parseMarkup(this.comment) : '–';
            },
        },
    };
</script>
